import React from "react";
import WarningTriangleIcon from "../images/WarningTriangleIcon.svg";
import SmallSizedModal from "../utils/UI/SmallSizedModal";
import { Box } from "@mui/material";

const MaintenanceDialog = () => {
    return (
        <>
            <SmallSizedModal
                open={true}
                headingIcon={WarningTriangleIcon}
                headingText={"Ongoing maintenance"}
            >
                <Box>SCHEDULED MAINTENANCE IN PROGRESS</Box>
                <Box>
                    Our system will be temporarily unavailable on Tuesday,
                    September 24, while we perform planned system maintenance
                </Box>
            </SmallSizedModal>
        </>
    );
};

export default MaintenanceDialog;
